import React, {useState} from "react";
import {trackTelClickRequestArticleInformation} from "../../Modules/ShoppingCart/Helpers/ga-track-hooks";
import sendContactRequest from "../../api/contact-request";

const ContactModal = ({contactDetails, onSend, onCancel, data}) => {
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [contactMethod, setContactMethod] = useState("email");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            setError("E-mailadres is verplicht.");
            return;
        }

        setError("");
        await sendContactRequest({
            ...data,
            email,
            phone,
            contactMethod,
        });
        onSend();
    };

    return (
        <div className="modal" style={{fontSize: "12px"}}>
            <div className="modal-content">
                <h4 className="text-center">Neem contact met mij op</h4>
                <div className="wrap-text lh-base my-2">
                    <p className="text-left lh-base">
                        Vul onderstaand formulier in en wij nemen contact met u op voor een actuele prijsindicatie en
                        levertijd van dit artikel.
                    </p>
                    <p className="text-left my-2 lh-base">
                        Wilt u direct iemand spreken bij KLINGER? Bel dan tijdens kantooruren naar:
                    </p>
                    {contactDetails && contactDetails.map((item) => (
                        <div key={item.name} className="row">
                            <div className="col-6 col-sm-5 text-left font-weight-bold">
                                {item.name}
                            </div>
                            <div className="col-6 col-sm-7 text-left">
                                <Phone phone={item.number}/>
                            </div>
                        </div>
                    ))}
                </div>
                <form onSubmit={handleSubmit} className="form-horizontal text-left">
                    <div className="form-group">
                        <div className="input-section">
                            <label htmlFor="" className="text-secondary font-weight-bold">
                                Uw e-mailadres (verplicht)
                            </label>
                            <div className="d-flex">
                                <div className="input-group">
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="E-mailadres"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="input-section">
                            <label htmlFor="" className="text-secondary font-weight-bold">
                                Uw telefoonnummer (optioneel)
                            </label>
                            <div className="d-flex">
                                <div className="input-group">
                                    <input
                                        type="tel"
                                        className="form-control"
                                        placeholder="Telefoonnummer"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <p>Hoe wilt u dat wij contact met u opnemen?</p>
                    <div className="form-group my-1">
                        <div className="checkbox">
                            <label className="text-secondary font-weight-bold d-flex">
                                <input
                                    type="checkbox"
                                    className="mr-1"
                                    checked={contactMethod === "email"}
                                    onChange={() => setContactMethod("email")}
                                />{" "}
                                Per e-mail
                            </label>
                        </div>
                    </div>
                    <div className="form-group my-1">
                        <div className="checkbox">
                            <label className="text-secondary font-weight-bold d-flex">
                                <input
                                    type="checkbox"
                                    className="mr-1"
                                    checked={contactMethod === "phone"}
                                    onChange={() => setContactMethod("phone")}
                                />{" "}
                                Telefonisch
                            </label>
                        </div>
                    </div>

                    {error && <p className="error">{error}</p>}

                    <div className="row">
                        <div className="col-6">
                            <div className="close">
                                <button className="btn btn-secondary d-flex w-100" type="button" onClick={onCancel}>
                                    <div className="btn-arrow">
                                        <svg
                                            width="50px"
                                            height="50px"
                                            viewBox="0 0 50 50"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                        >
                                            <g id="Symbols" stroke="none" strokeWidth="1" fill="none"
                                               fillRule="evenodd">
                                                <path
                                                    className="inline-svg"
                                                    d="M24.5639893,19 L26.9521116,19 L30.9973338,25.1216537 L26.9493623,31.2700005 L24.5639893,31.2700005 L28.6109479,25.1239623 L24.5639893,19 Z M19,19 L21.3879776,19 L25.4334892,25.1216537 L21.3849389,31.2700005 L19,31.2700005 L23.0469586,25.1239623 L19,19 Z"
                                                    id="Fill-1"
                                                ></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <span>Annuleren</span>
                                </button>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="accept">
                                <button className="btn btn-success d-flex w-100" type="submit">
                                    <div className="btn-arrow">
                                        <svg
                                            width="50px"
                                            height="50px"
                                            viewBox="0 0 50 50"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                        >
                                            <g id="Symbols"
                                               stroke="none"
                                               strokeWidth="1"
                                               fill="none"
                                               fillRule="evenodd">
                                                <path
                                                    className="inline-svg"
                                                    d="M24.5639893,19 L26.9521116,19 L30.9973338,25.1216537 L26.9493623,31.2700005 L24.5639893,31.2700005 L28.6109479,25.1239623 L24.5639893,19 Z M19,19 L21.3879776,19 L25.4334892,25.1216537 L21.3849389,31.2700005 L19,31.2700005 L23.0469586,25.1239623 L19,19 Z"
                                                    id="Fill-1"
                                                ></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <span>Verstuur</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

const Phone = ({phone}) => {
    const handleClick = (e) => {
        e.preventDefault();
        trackTelClickRequestArticleInformation();
        window.location.href = `tel:${phone}`;
    };

    return (
        <a href={`tel:${phone}`} onClick={handleClick}>{phone}</a>
    )
}

export default ContactModal;